import React from "react";

import Image from "next/image";

import FigureImage from "public/images/enerflo-vsr-collage.png";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "Enerflo VSR: Your 24/7 Virtual Solar Sales Rep";

const MainHero = () => (
  <HeroSection title={title} className="flex-col md:flex-row">
    <HeroSection.Content className="md:w-1/2">
      <HeroSection.Header className="md:items-start">
        <Heading tag="h1">{title}</Heading>
      </HeroSection.Header>
      <HeroSection.Description>Capture, Qualify, and Convert More Solar Leads — Automatically.</HeroSection.Description>
    </HeroSection.Content>

    <figure className="p-3 w-full xs:w-4/5 sm:w-3/4 md:w-1/2">
      <Image
        src={FigureImage}
        alt="Enerflo VSR: Virtual Sales Rep & Inside Sales in a Box for Solar."
        layout="responsive"
        quality={100}
        placeholder="blur"
        loading="eager"
        priority
        className="crispImage"
        sizes="(min-width: 768px) 50vw, 100vw"
      />
    </figure>
  </HeroSection>
);

export default MainHero;
